"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');



var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _campaignRecipientsAdd = require('shared/services/campaignRecipientsAdd');












const initialState = {
  adds: {},
  maxBatchSize: null,
  picking: {},
}

const reducer = _toolkit.createReducer.call(void 0, 
  initialState,
  builder => {
    const store = (s, add) => {
      s.adds[add.CampaignKey] = _campaignRecipientsAdd.mergeAdd.call(void 0, s.adds[add.CampaignKey], add)
    }

    builder.addCase(
      _actionCreators2.default.findCampaignsActions.SUCCESS,
      (s, a) => {
        const max = a.payload.MaxBatchSize
        if (typeof max === 'number' && max > 0) s.maxBatchSize = max
      },
    )

    builder.addCase(
      _actionCreators2.default.getCampaignRecipientsAddsActions.SUCCESS,
      (s, a) => { (_nullishCoalesce(a.payload.Adds, () => ( []))).forEach(add => store(s, add)) },
    )

    builder.addCase(
      _actionCreators2.default.addCampaignRecipientsActions.SUCCESS,
      (s, a) => { if (_campaignRecipientsAdd.isBackgroundAddReply.call(void 0, a.payload)) store(s, a.payload.Add) },
    )

    builder.addCase(_actionCreators2.default.campaignRecipientsAddNotificationAction, (s, a) => store(s, a.payload))
    builder.addCase(_actionCreators2.default.campaignRecipientsAddCompleteNotificationAction, (s, a) => store(s, a.payload.Add))

    builder.addCase(_actionCreators2.default.addPatientPickToBroadcastActions.REQUEST, (s, a) => {
      const key = _optionalChain([a, 'access', _ => _.meta, 'optionalAccess', _2 => _2.CampaignKey])
      if (key) s.picking[key] = true
    })
    const donePicking = (s, a) => {
      const key = _optionalChain([a, 'access', _3 => _3.meta, 'optionalAccess', _4 => _4.CampaignKey])
      if (key) delete s.picking[key]
    }
    builder.addCase(_actionCreators2.default.addPatientPickToBroadcastActions.SUCCESS, donePicking)
    builder.addCase(_actionCreators2.default.addPatientPickToBroadcastActions.FAILURE, donePicking)

    builder.addCase(_actionCreators2.default.logoutAction, () => initialState)
  },
)

exports. default = reducer
